
const fetchURL = "https://api.ravik.workers.dev/task";
const app = {
    fetchPost:async function(path, data) {
        const respose = await fetch(`${fetchURL}${path}`, {
            method:"POST",
            body:JSON.stringify(data)
        });
        return await respose.json();
    },
    fetchPut:async function(path, data) {
        const respose = await fetch(`${fetchURL}${path}`, {
            method:"PUT",
            body:JSON.stringify(data)
        });
        return await respose.json();
    },
    fetchGet:async function(path, data) {
        const respose = await fetch(`${fetchURL}${path}`, {
            method:"GET",
            //body:JSON.stringify(data)
        });
        return await respose.json();
    },
    taskFilter:function(users, statuses) {
        let taskFilterJson = {
            "users":[],
            "statuses":[]
        }
        if(localStorage.getItem("taskFilterJson")) {
            taskFilterJson = JSON.parse(localStorage.getItem("taskFilterJson"));
        }
        if(users && statuses) {
            taskFilterJson["users"] = users;
            taskFilterJson["statuses"] = statuses;
            localStorage.setItem("taskFilterJson", JSON.stringify(taskFilterJson));
        }
        else {
            if(users) {
                taskFilterJson["users"] = users;
                localStorage.setItem("taskFilterJson", JSON.stringify(taskFilterJson));
            }
            if(statuses) {
                taskFilterJson["statuses"] = statuses;
                localStorage.setItem("taskFilterJson", JSON.stringify(taskFilterJson));
            }
        }
        return taskFilterJson;
    }
}

export default app;